export default {
  HOME_ROUTE: '/',
  SESSIONS_ROUTE: '/sessions',
  COURTS_ROUTE: '/courts',
  COURTS_FILTERS_ROUTE: '/courts-filters',
  SIGNUP_ROUTE: '/signup',
  SIGNIN_ROUTE: '/signin',
  SINGLE_SESSION_ROUTE: sessionId => `/sessions/${sessionId}`,
  MY_BOOKINGS_ROUTE: '/my-bookings',
  ATTENDEES_LIST_ROUTE: accessToken => `/attendees-list/${accessToken}`,
  ERROR_PAGE: '/error',
  ACCOUNT_ROUTE: '/account',
  SUBSCRIPTION_PAGE: '/subscription',
  DEUCE_PREMIUM_PAGE: '/deuce-premium',
  UPDATE_CARD_ROUTE: '/update-card',
  FORGOT_PASSWORD_ROUTE: '/forgot-password',
  RESET_PASSWORD_ROUTE: '/reset-password'
};



// WEBPACK FOOTER //
// ./src/utils/routeConstants.js